import React, {Context, createContext} from 'react';

export default createContext<any>({});